import { render, staticRenderFns } from "./foot-table.vue?vue&type=template&id=af1e0788&scoped=true&"
import script from "./foot-table.vue?vue&type=script&lang=js&"
export * from "./foot-table.vue?vue&type=script&lang=js&"
import style0 from "./foot-table.vue?vue&type=style&index=0&id=af1e0788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1e0788",
  null
  
)

export default component.exports